/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Booking_Calendar_Day_SelectedInputs */

const en_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, selected`)
};

const es_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, seleccionado`)
};

const de_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, ausgewählt`)
};

const zh_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}，已选择`)
};

const ar_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}، محدد`)
};

const fr_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, sélectionné`)
};

const vi_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, đã chọn`)
};

const sw_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, imechaguliwa`)
};

const th_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} (เลือกแล้ว)`)
};

const bs_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, odabrano`)
};

const ja_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}、選択済み`)
};

const ko_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, 선택됨`)
};

const pt_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, selecionado`)
};

const it_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, selezionato`)
};

const sv_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, vald`)
};

const nl_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, geselecteerd`)
};

const da_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, valgt`)
};

const nb_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, valgt`)
};

const fi_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, valittu`)
};

const pl_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, wybrano`)
};

const ru_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, выбрано`)
};

const tr_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, seçili`)
};

const hi_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, चयनित`)
};

const id_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, dipilih`)
};

const ms_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, dipilih`)
};

const cs_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, vybráno`)
};

const el_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, επιλεγμένη`)
};

const he_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, נבחר`)
};

const af_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, gekies`)
};

const hu_booking_calendar_day_selected = /** @type {(inputs: Booking_Calendar_Day_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}, kijelölve`)
};

/**
* | output |
* | --- |
* | "{date}, selected" |
*
* @param {Booking_Calendar_Day_SelectedInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_calendar_day_selected = /** @type {((inputs: Booking_Calendar_Day_SelectedInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Calendar_Day_SelectedInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_calendar_day_selected(inputs)
	if (locale === "de") return de_booking_calendar_day_selected(inputs)
	if (locale === "zh") return zh_booking_calendar_day_selected(inputs)
	if (locale === "ar") return ar_booking_calendar_day_selected(inputs)
	if (locale === "fr") return fr_booking_calendar_day_selected(inputs)
	if (locale === "vi") return vi_booking_calendar_day_selected(inputs)
	if (locale === "sw") return sw_booking_calendar_day_selected(inputs)
	if (locale === "th") return th_booking_calendar_day_selected(inputs)
	if (locale === "bs") return bs_booking_calendar_day_selected(inputs)
	if (locale === "ja") return ja_booking_calendar_day_selected(inputs)
	if (locale === "ko") return ko_booking_calendar_day_selected(inputs)
	if (locale === "pt") return pt_booking_calendar_day_selected(inputs)
	if (locale === "it") return it_booking_calendar_day_selected(inputs)
	if (locale === "sv") return sv_booking_calendar_day_selected(inputs)
	if (locale === "nl") return nl_booking_calendar_day_selected(inputs)
	if (locale === "da") return da_booking_calendar_day_selected(inputs)
	if (locale === "nb") return nb_booking_calendar_day_selected(inputs)
	if (locale === "fi") return fi_booking_calendar_day_selected(inputs)
	if (locale === "pl") return pl_booking_calendar_day_selected(inputs)
	if (locale === "ru") return ru_booking_calendar_day_selected(inputs)
	if (locale === "tr") return tr_booking_calendar_day_selected(inputs)
	if (locale === "hi") return hi_booking_calendar_day_selected(inputs)
	if (locale === "id") return id_booking_calendar_day_selected(inputs)
	if (locale === "ms") return ms_booking_calendar_day_selected(inputs)
	if (locale === "cs") return cs_booking_calendar_day_selected(inputs)
	if (locale === "el") return el_booking_calendar_day_selected(inputs)
	if (locale === "he") return he_booking_calendar_day_selected(inputs)
	if (locale === "af") return af_booking_calendar_day_selected(inputs)
	if (locale === "hu") return hu_booking_calendar_day_selected(inputs)
	return en_booking_calendar_day_selected(inputs)
});